import { DangerouslySetHtmlContent } from '@/components/content/DangerouslySetHtmlContent/DangerouslySetHtmlContent';
import { contactBoxIconsStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/contactBoxIconsStyles';
import { iconComponentStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/iconComponentStyles';
import { ContactType } from '@/data/utils/dataMapContent';
import { Box, Grid, Typography } from '@mui/material';
import { ErrorBoundary } from 'next/dist/client/components/error-boundary';
import dynamic from 'next/dynamic';

export const AssetIcon = ({ icon, iconSize }: { icon: string; iconSize: number }) => (
	<img
		src={icon}
		alt={icon}
		width={iconSize}
		height={iconSize}
		className="lazyload"
		color={'primary'}
	/>
);

export const ContactBoxIcon = ({ icon }: { icon: string }) => {
	const iconMap: Record<string, React.ComponentType<any>> = {
		PhoneSharp: dynamic(() => import('@mui/icons-material/PhoneSharp'), {
			loading: () => <div>...</div>,
			ssr: false,
		}),
		ForumSharp: dynamic(() => import('@mui/icons-material/ForumSharp'), {
			loading: () => <div>...</div>,
			ssr: false,
		}),
		EmailSharp: dynamic(() => import('@mui/icons-material/EmailSharp'), {
			loading: () => <div>...</div>,
			ssr: false,
		}),
	};

	const getAssetIconWithProps = () => <AssetIcon icon={icon} iconSize={22} />;

	if (icon.includes('https')) {
		return <AssetIcon icon={icon} iconSize={22} />;
	}
	if (icon === '') {
		return;
	} else {
		const IconComponent = iconMap[icon];

		return (
			<ErrorBoundary errorComponent={getAssetIconWithProps}>
				<IconComponent sx={iconComponentStylesSx} />
			</ErrorBoundary>
		);
	}
};

export const ContactBoxIcons = ({ contacts }: { contacts: ContactType[] }) => {
	const hasScriptTag = (html: string): boolean => /^\s*<script[\s>]/i.test(html);
	return (
		<Grid sm={12} md={8} item sx={contactBoxIconsStylesSx}>
			{contacts && contacts.length > 0
				? contacts.map((contact, i) => (
						<Box key={contact.title + i}>
							<Box display={'flex'} gap={'5px'}>
								<ContactBoxIcon icon={contact.icon} />
								<Typography variant={'bodyBaseline'}>{!!contact && contact.title}</Typography>
							</Box>
							{!!contact && !hasScriptTag(contact.subtitle) && (
								<DangerouslySetHtmlContent html={contact.subtitle} executeScripts />
							)}
						</Box>
				  ))
				: null}
		</Grid>
	);
};
